<template lang="pug">
include /mixins

+b.ti-stripe-view(
  style='padding: 20px'
)
  v-caption(size='5' variant='bold' style='padding-bottom: 20px') {{ _("c Stripe payment") }}
  +e.content
    +e.loader
    +e.form
      form#payment-form.form-loader
        #error-message
        +e.load-error(v-if='loadError')
          p(style='color: red') {{ loadError }}
          +b.control-button--variant_success.--border_whole.BUTTON(
            style='margin-top: 12px'
            type='button'
            @click='start'
          )
            +e.element--size_lg
              +b.caption--size_4.--variant_bold.SPAN {{ _('Try again') }}
        #payment-element
          // Elements will create form elements here
        div#payment-request-button
        +e.button(v-show='!loadError')
          .card__panel.card__panel--offset_bottom
            +b.row--justification_end
              +b.cell.cols--12.--6-sm.--12-md.--6-xl
                +b.control-button--variant_success.--border_whole.BUTTON#submit(
                  style='margin-top: 12px'
                  :disabled='getCurrentTimer > 0 ? false : true'
                  type='submit'
                )
                  +e.element--size_lg
                    +b.caption--size_4.--variant_bold.SPAN {{ _('Pay now') }}

</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

import Checkbox from '@cabinet/components/forms/blocks/Checkbox'
import { successHandler, errorHandler } from '@cabinet/util'
import { Card, createToken } from 'vue-stripe-elements-plus'
import AutocompleteMixin from './../../../mixin/AutocompleteMixin'
import StripeBtn from '@cabinet/components/forms/StripeBtn'

import OrdersService from '@cabinet/services/api/orders'
import PaymentsService from '@cabinet/services/api/payments'
import UiSelect from '@cabinet/components/forms/blocks/UiSelect'
import UiCreditCardView from '@cabinet/components/forms/UiCreditCardView'

import StripePayment, { reportStripeError } from '@cabinet/packages/stripe/src/main'
// import StripePayment from '@cabinet/packages/stripe/src/main'

export default {
  components: {
    UiCreditCardView,
    Checkbox,
    StripeCard: Card,
    StripeBtn,
    UiSelect,
  },

  props: {
    dataInfo: {
      type: Object
    },
    formData: {
      type: Object
    },
    totalPrice: {
      required: true
    },
    currency: {
      required: false,
      default: 'USD'
    },
    order: {},
    redirect: {},
    promise: {},
    total: {},
  },
  data() {
    return {
      complete: false,
      loading: false,
      loadError: '',
    }
  },
  mounted() {
    this.start()
  },
  beforeDestroy() {
    if (this.stripeInstance) this.stripeInstance.destroy()
  },
  computed: {
    ...mapState('userModule', ['userData']),
    ...mapGetters('cartModule', ['getCurrentTimer']),
    totalPriceConverted() {
      return parseFloat(this.total) * 100
    }
  },
  methods: {
    // creates the intent once, then (re)loads the Stripe form for it; also used by "Try again"
    start() {
      this.loadError = ''
      const form = this.$el.querySelector('#payment-form')
      form.classList.add('form-loader')
      const ready = this.stripeInstance ? this.stripeInstance.loadScript() : this.createIntent()
      ready.then(() => {
        form.classList.remove('form-loader')
      }, err => {
        form.classList.remove('form-loader')
        const data = err.response && err.response.data
        this.loadError = (data && (data.error || data.detail)) ||
          this._('Payment form failed to load. Please check your connection and try again.')
        reportStripeError({
          cart: this.order.id,
          payment: this.stripeInstance ? this.stripeInstance.payment : null,
          stage: this.stripeInstance ? 'stripe' : 'intent',
          message: err.response ? `HTTP ${err.response.status}` : err.message,
        })
      })
    },
    createIntent() {
      return PaymentsService.createIntent(
        {
          currency: this.currency == "CA$" ? 'CAD' : 'USD', 
          amount: this.totalPriceConverted, 
          payment_parameters: {
            setup_future_usage: 'off_session',
            automatic_payment_methods: { enabled: true },
            confirm: false,
            payment_method_options: {
              'card': {
                'setup_future_usage': 'off_session',
              },
            }, 
          } ,
          "automatic_payment_methods": [
            "card",
          ],
          referer: window.location.href,
          cart: this.order.id,
          provider: this.order.provider,
        }
      ).then(({ data: { client_secret, payment } } ) => {
        this.stripeInstance = new StripePayment(this.totalPriceConverted, this.dataInfo.token, client_secret, this.order.id, 'payment-form', payment, this.redirect, {...this.formData, ...this.dataInfo})
        if (this.only_secure) {
          this.opened = true
          return this.stripeInstance.loadSecureScript(this.order)
        }
        this.stripeInstance.complete()
        this.opened = true
        return this.stripeInstance.loadScript()
      })
    },
  }
}
</script>
